import { slugify } from '../utils/slugify';

// --- Data for Adult Education Course Packages ---
export const coursePackagesData = [
    {
        id: 1,
        name: "Developing Learner Agency",
        slug: slugify("Developing Learner Agency"),
        icon: "💡",
        tileDescription: "A course for educators on how to empower learners to take control of their own learning journey.",
        overview: "This course teaches educators how to support learners to take control of their learning journey and develop skills for lifelong success. By integrating principles of learner agency into our practice educators can support learners to take greater control of their educational journey, making their learning more enjoyable, engaging, and effective. These workshops are for anyone working in education with an interest in supporting learners to succeed.",
        workshops: [
            "Workshop 1 | Learner Agency | Developing a positive learner identity",
            "Workshop 2 | Learner Agency | Developing personal learning strategies",
            "Workshop 3 | Learner Agency | Supporting learners to organise their learning",
            "Workshop 4 | Learner Agency | Supporting learners to solve problems, innovate, and learn effectively"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "NZ$2,500 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "NZ$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "NZ$5,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Explore these resources to deepen your understanding of learner agency and discover practical strategies for fostering it in your educational context. These videos offer diverse perspectives and actionable insights.",
            videos: [
                "https://www.youtube.com/embed/S_8XV_t_pM4",
                "https://www.youtube.com/embed/5zTuY-Ie_VE"
            ]
        }
    },
    {
        id: 2,
        name: "Numeracy Toolbox 1: Developing adult learners’ number skills",
        slug: slugify("Numeracy Toolbox 1: Developing adult learners’ number skills"),
        icon: "🔢",
        tileDescription: "For educators: Build your confidence and skills to deliver high-quality numeracy provision to lower-skilled adults.",
        overview: "This course supports educators to deliver high quality numeracy provision to lower skilled adult learners. It is applicable to a variety of educational environments such as community courses, formal courses, or workplace courses. It is suitable for all teaching and learning support practitioners seeking to expand their understanding and practice. Note, this course is suitable for educators who do not like maths!",
        workshops: [
            "Workshop 1 | Numeracy Toolbox 1 | Understanding how adult difficulties with numbers affect performance",
            "Workshop 2 | Numeracy Toolbox 1 | Simple strategies to start delivering effective numeracy provision",
            "Workshop 3 | Numeracy Toolbox 1 | Developing addition, subtraction, and multiplicative thinking",
            "Workshop 4 | Numeracy Toolbox 1 | Creating a toolbox of contextualised numeracy tasks",
            "Workshop 5 | Numeracy Toolbox 1 | Introduction to resources for developing learners’ skills"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "NZ$2,500 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "NZ$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "NZ$5,000 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Building confidence in numeracy starts with the right tools and strategies. These resources provide foundational knowledge and teaching techniques to support adult learners in developing essential number skills.",
            videos: [
                "https://www.youtube.com/embed/4y_igv_p_h0",
                "https://www.youtube.com/embed/z9v_p_9Jk4M"
            ]
        }
    },
    {
        id: 3,
        name: "Numeracy Toolbox 2: Developing learners’ fractions, decimals, percentages and proportional thinking",
        slug: slugify("Numeracy Toolbox 2: Developing learners’ fractions, decimals, percentages and proportional thinking"),
        icon: "📊",
        tileDescription: "For educators: Learn to teach fractions, decimals, and percentages in an easy and fun manner.",
        overview: "This course supports educators to deliver high-quality numeracy provision to adult learners who are required to work with decimals, percentages, fractions or proportional reasoning. Many tutors have difficulty with these concepts themselves and must teach them as part of work or course requirements. This course presents the concepts and teaching approaches in an easy and fun manner.",
        workshops: [
            "Workshop 1 | Numeracy Toolbox 2 | Understanding decimals, fractions, percentages, and proportional reasoning",
            "Workshop 2 | Numeracy Toolbox 2 | Proportional reasoning in the workplace and problem-solving",
            "Workshop 3 | Numeracy Toolbox 2 | A model for developing adult learners’ numeracy skills",
            "Workshop 4 | Numeracy Toolbox 2 | Using diagnostic assessment to target and develop key skills",
            "Workshop 5 | Numeracy Toolbox 2 | Strategies for teaching proportional reasoning, fractions, and decimals",
            "Workshop 6 | Numeracy Toolbox 2 | Introduction to resources for developing learners’ skills"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "NZ$2,500 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "NZ$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "NZ$5,000 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Fractions, decimals, and percentages can be challenging concepts. The following videos break down these topics into easy-to-understand segments and offer innovative teaching methods to make learning fun and effective.",
            videos: [
                "https://www.youtube.com/embed/do_rc3aSM2E",
                "https://www.youtube.com/embed/p_s4gE_m_aE"
            ]
        }
    },
    {
        id: 4,
        name: "Numeracy Toolbox 3: Developing measurements skills and statistical reasoning skills",
        slug: slugify("Numeracy Toolbox 3: Developing measurements skills and statistical reasoning skills"),
        icon: "📏",
        tileDescription: "For educators: Simple and effective ways to develop skills for Adult Unit Standards 26627 & 2662.",
        overview: "This course was developed to support educators working with Adult Unit Standards 26627 and 2662. It provides simple yet effective ways to develop learner’s measurement and statistical reasoning skills, and alignment with unit standard criteria.",
        workshops: [
            "Workshop 1 | Numeracy Toolbox 3 | Introduction to Adult Unit Standards 26627 & 2662",
            "Workshop 2 | Numeracy Toolbox 3 | Effective strategies for developing measurement skills",
            "Workshop 3 | Numeracy Toolbox 3 | Practical approaches to teaching statistical reasoning",
            "Workshop 4 | Numeracy Toolbox 3 | Aligning learning activities with unit standard criteria",
            "Workshop 5 | Numeracy Toolbox 3 | Introduction to measurement and statistics resources"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "NZ$2,500 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "NZ$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "NZ$5,000 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Measurement and statistics are practical, real-world skills. These resources will help you teach these concepts in a hands-on, engaging way that connects with adult learners' everyday lives and professional needs.",
            videos: [
                "https://www.youtube.com/embed/wzNiu3wCoS0",
                "https://www.youtube.com/embed/7D0y_g-M5es"
            ]
        }
    },
    {
        id: 5,
        name: "Problem solving: Developing and applying numeracy skills to become a master problem solver",
        slug: slugify("Problem Solving & Numeracy Skills"),
        icon: "🧩",
        tileDescription: "Equip learners with practical numeracy strategies and critical thinking tools to solve real-world problems.",
        overview: "This fun course equips tutors with a toolbox of strategies to develop their learners’ numeracy and problem-solving skills. Tutors will leave with a bounty of engaging activities designed to bring energy and learning back to the adult classroom. The focus is on practical problem-solving skills designed to be used by learners in the workplace and throughout their lives, moving beyond rote mathematics to true comprehension.",
        workshops: [
            "Workshop 1 | Problem Solving | Learn the secrets to effective problem-solving (and how to teach them)",
            "Workshop 2 | Problem Solving | Developing your learners’ problem-solving mindset",
            "Workshop 3 | Problem Solving | Building a toolbox of fun learning activities"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "NZ$2,500 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal with printable numeracy activities.",
                    "Includes a guide for aligning problem-solving content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "NZ$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on gamification and engagement strategies.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "NZ$5,000 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce concepts.",
                    "Extended access to our full suite of digital resources and numeracy learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Developing strong problem-solving skills is critical for navigating modern life and work. The resources below explore how to teach numeracy effectively and strategies for turning learners into independent thinkers.",
            videos: [
                "https://www.youtube.com/embed/wAtBUIGOAcI",
                "https://www.youtube.com/embed/F4g9m2PytxA"
            ]
        }
    },
    {
        id: 6,
        name: "Dyscalculia: Supporting learner success",
        slug: slugify("Dyscalculia: Supporting learner success"),
        icon: "🧠",
        tileDescription: "Learn to support adult learners with this neurodiversity, often called 'maths dyslexia'.",
        overview: "Dyscalculia is sometimes referred to as the ‘maths version of dyslexia’, yet the differences between the two are vast. Dyscalculia is a type of neurodiversity that impacts how children process magnitude, numbers, and eventually arithmetic problems. This can make school mathematics deeply unpleasant, in fact often an assault on their sense of self-worth. By the time these children become adults, these negative experiences and ongoing difficulties have often consolidated into deep beliefs about their own mathematical inadequacy. Imagine if we could make a difference to their numeracy skills and beliefs about themselves! We can make a huge difference. In this workshop we will explore what dyscalculia is, what the research has discovered, and, most importantly, how we might work successfully with adults with dyscalculia.",
        workshops: [
            "Workshop 1 | Dyscalculia | What is dyscalculia?",
            "Workshop 2 | Dyscalculia | Conceptualising and diagnosing dyscalculia",
            "Workshop 3 | Dyscalculia | How dyscalculia interferes with adult life, study and employment",
            "Workshop 4 | Dyscalculia | Strategies that work with dyscalculic adults",
            "Workshop 5 | Dyscalculia | Designing and implementing effective learning plans",
            "Workshop 6 | Dyscalculia | Using resources to support and develop learners' skills"
        ],
        tiers: [
            {
                name: "Virtual Workshop Series",
                price: "NZ$2,500 + GST",
                deliveryMode: "Fully online for a group of up to 20 attendees.",
                features: [
                    "Three interactive 1-hour online workshops, delivered over three weeks.",
                    "Full access to our supporting online resource portal.",
                    "Includes a guide for aligning content with unit standards.",
                ]
            },
            {
                name: "Signature On-Site Intensive",
                price: "NZ$3,000 + GST",
                deliveryMode: "A full-day workshop delivered face-to-face at your location for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "All supporting online resources included for continued learning.",
                    "A practical, hands-on workshop focused on criteria alignment.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            },
            {
                name: "Signature Plus Masterclass Program",
                price: "NZ$5,000 + GST",
                deliveryMode: "A full-day in-person workshop at your location, enhanced with three follow-up online sessions and extended resource access for up to 20 attendees.",
                features: [
                    "A comprehensive full-day face-to-face workshop at your premises.",
                    "Three follow-up 1-hour online workshops delivered in the weeks after the in-person session to reinforce and deepen learning.",
                    "Extended access to our full suite of digital resources and learning materials.",
                    "Ongoing support for aligning content with unit standards and implementation in practice.",
                    "*Please note: Facilitator's travel expenses are quoted separately based on location.*"
                ]
            }
        ],
        resources: {
            blurb: "Understanding and supporting learners with dyscalculia can transform their educational experience. These resources offer insights into this learning difference and provide strategies to help educators create a more inclusive and effective learning environment.",
            videos: [
                "https://www.youtube.com/embed/i_H_wI2fSpg",
                "https://www.youtube.com/embed/jRDMy92dF_0"
            ]
        }
    }
];